import { fetchClient } from '../../Utils/helpers';
import {
  getBrowserId,
  getBrowserIdExpired,
  setBrowserId,
  setBrowserIdExpired,
  setExpireTime,
  setToken,
  setUserData,
} from '../../Utils/storages';
import {
  CREATE_NEW_PASS,
  FORGOT_PASS,
  LOGIN,
  OTP_VERIF,
  REGISTRATION,
  RESEND_OTP,
  SIGNUP_VERIF,
} from '../actionTypes';

export function registration(data) {
  return {
    type: REGISTRATION,
    payload: fetchClient({
      method: 'POST',
      url: '/auth/register',
      data,
    }),
  };
}

export function resendLink(data) {
  return {
    type: REGISTRATION,
    payload: fetchClient({
      method: 'POST',
      url: '/auth/register/resend',
      data,
    }),
  };
}

export function login(data) {
  const now = Date.now();
  let browserId = getBrowserId() || `${data.email}${now}`;
  let browserIdExp = getBrowserIdExpired() || 0;

  return {
    type: LOGIN,
    payload: fetchClient({
      method: 'POST',
      url: '/auth/login',
      data: {
        ...data,
        browser_id: browserId,
      },
    }).then((res) => {
      if (browserIdExp < now) { // if expired
        browserId = `${data.email}${now}`;
        browserIdExp = now + (1000 * 60 * 60 * 2); // new broser_id_expired for 2 hrs
        setBrowserId(browserId);
        setBrowserIdExpired(browserIdExp);
      }

      if (res.data?.data?.token) {
        setToken(res.data.data.token);
        setUserData(res.data.data.user);
      }

      return res;
    }),
  };
}

export function resendOTP(data) {
  return {
    type: RESEND_OTP,
    payload: fetchClient({
      method: 'POST',
      url: '/auth/login/resend',
      data,
    }),
  };
}

export function signupVerif(data, email) {
  return {
    type: SIGNUP_VERIF,
    payload: fetchClient({
      method: 'POST',
      url: `/auth/register/verification/${email}`,
      data,
    }),
  };
}

export function otpVerif(data, email) {
  const browserId = getBrowserId();
  return {
    type: OTP_VERIF,
    payload: fetchClient({
      method: 'POST',
      url: `/auth/login/verification/${email}`,
      data: {
        ...data,
        browser_id: browserId,
      },
    }).then((res) => {
      const now = new Date().getTime();
      setExpireTime((30 * 60 * 1000) + now);
      setToken(res.data.data.token);
      setUserData(res.data.data.user);
      return res;
    }),
  };
}

export function forgotPassword(email) {
  return {
    type: FORGOT_PASS,
    payload: fetchClient({
      method: 'POST',
      url: '/auth/forgot-password',
      data: { email },
    }),
  };
}

export function createNewPass(data, email) {
  return {
    type: CREATE_NEW_PASS,
    payload: fetchClient({
      method: 'POST',
      url: `/auth/forgot-password/verification/${email}`,
      data,
    }),
  };
}
